import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"width":"40rem","max-height":"60vh"} }
const _hoisted_2 = { class: "grid grid-cols-2 gap-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_4 = { class: "grid grid-cols-2 gap-6" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "py-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_6 = { class: "grid grid-cols-2 gap-6" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, " Bukti Transfer ", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_10 = {
  key: 0,
  class: "border border-dashed rounded my-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_up_verification_detail_lazy_load = _resolveComponent("top-up-verification-detail-lazy-load")!
  const _component_error_message = _resolveComponent("error-message")!
  const _component_data_wrapper = _resolveComponent("data-wrapper")!
  const _component_chips = _resolveComponent("chips")!
  const _component_Title = _resolveComponent("Title")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_top_up_verification_detail_lazy_load, { key: 0 }))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (_ctx.error)
            ? (_openBlock(), _createBlock(_component_error_message, {
                key: 0,
                "error-type": _ctx.errorCause
              }, null, 8, ["error-type"]))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createVNode("div", _hoisted_2, [
                  _createVNode(_component_data_wrapper, {
                    label: "ID",
                    value: _ctx.detail.id
                  }, null, 8, ["value"]),
                  _createVNode(_component_data_wrapper, {
                    label: "ID Transaksi Genesis",
                    value: _ctx.detail.genesisTransactionId
                  }, null, 8, ["value"]),
                  _createVNode(_component_data_wrapper, {
                    label: "Nama Partner",
                    value: _ctx.detail.actorName
                  }, null, 8, ["value"]),
                  _createVNode(_component_data_wrapper, { label: "Status" }, {
                    default: _withCtx(() => [
                      (_ctx.detail.status)
                        ? (_openBlock(), _createBlock(_component_chips, _mergeProps({
                            key: 0,
                            class: "my-1 capitalize",
                            rounded: ""
                          }, _ctx.chipsStatusStyle, {
                            label: _ctx.detail.status.replace('_', ' ')
                          }), null, 16, ["label"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_data_wrapper, {
                    label: "Jumlah Permintaan",
                    value: _ctx.formatPrice(_ctx.detail.amount)
                  }, null, 8, ["value"]),
                  _createVNode(_component_data_wrapper, {
                    label: "Jumlah Terverifikasi",
                    value: _ctx.detail.amountVerified
                  }, null, 8, ["value"]),
                  _createVNode(_component_data_wrapper, {
                    label: "Alasan Penolakan",
                    value: _ctx.detail.reasonRejected
                  }, null, 8, ["value"])
                ]),
                _hoisted_3,
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_Title, {
                    class: "text-16px",
                    label: "Detail Rekening Pengirim"
                  }),
                  _createVNode(_component_Title, {
                    class: "text-16px",
                    label: "Detail Rekening Penerima"
                  }),
                  _createVNode(_component_data_wrapper, {
                    label: "Nama Bank Pengirim",
                    value: _ctx.detail.senderBankName
                  }, null, 8, ["value"]),
                  _createVNode(_component_data_wrapper, {
                    label: "Nama Bank Penerima",
                    value: _ctx.detail.recipientBankName
                  }, null, 8, ["value"]),
                  _createVNode(_component_data_wrapper, {
                    label: "Nama Rekening Pengirim",
                    value: _ctx.detail.senderBankAccountName
                  }, null, 8, ["value"]),
                  _createVNode(_component_data_wrapper, {
                    label: "Nama Rekening Penerima",
                    value: _ctx.detail.recipientBankAccountName
                  }, null, 8, ["value"]),
                  _createVNode(_component_data_wrapper, {
                    label: "No. Rekening Pengirim",
                    value: _ctx.detail.senderBankAccountNumber
                  }, null, 8, ["value"]),
                  _createVNode(_component_data_wrapper, {
                    label: "No. Rekening Penerima",
                    value: _ctx.detail.recipientBankAccountNumber
                  }, null, 8, ["value"])
                ]),
                _hoisted_5,
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_data_wrapper, {
                    label: "Tanggal Transaksi",
                    value: _ctx.formatDate(_ctx.detail.createdAt),
                    caption: _ctx.detail.createdBy
                  }, null, 8, ["value", "caption"]),
                  _createVNode(_component_data_wrapper, {
                    label: "Tanggal Diverifikasi",
                    value: _ctx.formatDate(_ctx.detail.verifiedAt),
                    caption: _ctx.detail.verifiedBy
                  }, null, 8, ["value", "caption"])
                ]),
                _createVNode(_component_data_wrapper, {
                  class: "py-6",
                  label: "Bukti Transfer"
                }, {
                  label: _withCtx(() => [
                    _createVNode("div", _hoisted_7, [
                      _hoisted_8,
                      (_ctx.detail.fileOfProof)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = () => _ctx.downloadFile(_ctx.detail.fileOfProof)),
                            class: "flex text-12px items-center gap-x-2 cursor-pointer text-red-lp-400"
                          }, [
                            _hoisted_9,
                            _createVNode("img", {
                              src: require('@/app/ui/assets/svg/download-new.svg'),
                              alt: "download",
                              class: "w-4 max-w-none"
                            }, null, 8, ["src"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  default: _withCtx(() => [
                    (_ctx.detail.fileOfProof)
                      ? (_openBlock(), _createBlock("div", _hoisted_10, [
                          _createVNode("img", {
                            class: "mx-auto",
                            style: {"height":"13rem","width":"auto"},
                            src: _ctx.detail.fileOfProof,
                            alt: ""
                          }, null, 8, ["src"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 64))
        ], 64))
  ]))
}